import { createFileRoute } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { useRequireRole } from '@/hooks/use-require-role'

function WebappLayout() {
  useRequireRole(['DOCTOR'])
  return <AuthenticatedLayout />
}

export const Route = createFileRoute('/_authenticated')({
  component: WebappLayout,
})
